export enum EvaluationTypes {
  assessment = "assessment",
  survey = "survey"
}

export enum EvaluationArticles {
  assessment = "an",
  survey = "a"
}
